const generateUploadUrl = '/generate_upload_url/';
const generateDownloadUrl = '/generate_download_url/';
const uploadMissions = '/upload_missions/';

export const uploadEndpoints = { generateUploadUrl, generateDownloadUrl, uploadMissions };
